import { Col, DatePicker, Row, Select } from 'antd'
import React from 'react'
import ButtonComp from '../../Components/ButtonComp/ButtonComp'
import LineCards from '../../Components/OEE/LinePerMonitor/LineCards'
import LineCharttt from '../../Components/OEE/LinePerMonitor/LineChart'
import LineCharttwo from '../../Components/OEE/LinePerMonitor/LineCharttwo'
import LinePieChart from '../../Components/OEE/LinePerMonitor/LinePieChart'
import LineTable from '../../Components/OEE/LinePerMonitor/LineTable'
import LineTable2 from '../../Components/OEE/LinePerMonitor/LineTable2'
import { cancelCircle, favchart, messageQuestion, HiOutlineRefresh, cube } from '../../Utils/imports'
import "./oee.css"
import SupportButton from './Support'
import ForceShiftStop from '../../Components/LineOperatorComp/ForceShiftStop'

const LinePerMonitor = () => {

    const onDateChange = (date, dateString) => {
        console.log(date, dateString);
    };
    return (
        <div className='oee-linepermonitor'>
            <Row className='oee-linepermonitor-row-1'>
                <Col className='tabs'>
                    <h1 className='f-size20'>Line Performance Monitor</h1>
                </Col>
                <Col className='buttons'>
                    <ButtonComp theme="gray" text='Speed:' textStrong='0 Prod/min' icon={<img src={favchart} />} />
                    <ButtonComp theme="gray" text='Last Updated:' textStrong='12:15:00 am' icon={<HiOutlineRefresh style={{
                        background: "#909AB4",
                        color: "white",
                        padding: '3px',
                        borderRadius: "100%",
                        fontSize: "18px"
                    }} />} />
                    <ButtonComp theme="gray" text='Product:' textStrong='Text Product' icon={<img src={cube} />} />
                    <ForceShiftStop />
                    <SupportButton />
                </Col>
            </Row>
            <Row className='oee-linepermonitor-row-2'>
                <DatePicker onChange={onDateChange} className="oee-dashboard-row-2-datepicker" placeholder='Date' />
                <Select
                    defaultValue="Morning"
                    style={{
                        width: 150,
                    }}
                />
            </Row>
            <Row className='oee-linepermonitor-row-3' >
                <div className='col-1'>
                    <Row className=''>
                        <LineCards dataname={'Availability'} price={'54.20'} />
                    </Row>
                    <Row className=''>
                        <LineCards dataname={'Performance'} price={'54.20'} />
                    </Row>
                    <Row className=''>
                        <LineCards dataname={'Quality'} price={'54.20'} />
                    </Row>
                    <Row className=''>
                        <LineCards dataname={'OEE'} price={'54.20'} />
                    </Row>
                </div>
                <div className="col-2">
                    <div className='head'>
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}>Speed</span>
                        <span style={{ color: "#1E6EFE", backgroundColor: "#1e6efe1a", borderRadius: "8px", padding: "5px", fontWeight: "bold", fontSize: "12px" }}>Average Speed: 70</span>
                    </div>
                    <div className='graph'>
                        <LineCharttt />
                    </div>
                </div>
            </Row>

            <Row className='oee-linepermonitor-row-4'>
                <Col md={15} xs={24}>
                    <Row className='c-width'>
                        {/* <Col style={{background:'none'}} md={6}></Col> */}
                        <Col className='f-size16 f-bold f-alignment ' md={18} xs={24} >Hourly Good Output Count Actual VS Targets</Col>
                        <Col className='f-size16 f-bold f-alignment ' md={6} xs={24}>Hourly Actual OEE%</Col>
                    </Row>
                    <LineTable />
                </Col>
                <Col md={8} xs={24}>
                    <Col className='f-size16 f-bold f-alignment1' style={{
                        background: '#F6F8FA', padding: '15px', borderRadius: '10px 10px 0px 0px'
                    }}>Top 10 Downtime</Col>
                    <LineTable2 />
                </Col>
            </Row>
            <Row className='oee-linepermonitor-row-5'>
                <div className='head'>
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>Hourly Good Output v/s Target Output</span>
                    <div className='dflex alignCenter justifyCenter gap10'>
                        <div className='graph-info'>
                            <div className='dot' style={{ backgroundColor: "#C7DAFB", width: "11px", height: "11px" }}></div>
                            <span>Target</span>
                        </div>
                        <div className='graph-info'>
                            <div className='dot' style={{ backgroundColor: "#1E6EFE", width: "11px", height: "11px" }}></div>
                            <span>Actual</span>
                        </div>
                        <div className='graph-info'>
                            <div className='dot' style={{ backgroundColor: "#EB5757", width: "11px", height: "11px" }}></div>
                            <span>Shortfall</span>
                        </div>
                    </div>
                </div>
                <Col style={{ height: "330px", width: "98%" }} >
                    <LineCharttwo />
                </Col>
            </Row>
            <Row span={24} style={{ marginTop: '10px', marginBottom: "20px" }} >
                <Col style={{ width: "100%", margin: 'auto' }} >
                    <LinePieChart />
                </Col>
            </Row>
        </div>
    )
}

export default LinePerMonitor